<template>
  <div class="modal-container clearfix">
    <div v-if="(isUpdate || isDetail) && !isTax">创建人：{{ formData[0].createUser }}
      <span
          v-if="isHavePermission('agreement2.0:createTime')">| 创建日期：{{ formData[0].createTime | timeFormatDate }}</span>
    </div>
    <div class="add-box clearfix" style="margin-top: 10px">
      <vxe-table
          show-overflow
          ref="xTable1"
          class="table-style"
          max-height="400"
          :loading="loading"
          :align="isDetail ? 'center' : ''"
          :auto-resize="true"
          :edit-rules="tableRules"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="numb" title="合同编号" v-if="isDetail">
          <template v-slot="{ row }">
            <span>{{ row.numb }}</span>
<!--            <vxe-input v-else v-model="row.numb" placeholder="选填" :disabled="isUpdate"></vxe-input>-->
          </template>
        </vxe-table-column>
        <vxe-table-column field="title" title="合同名称">
          <template v-slot:header>
            <span style="color: red" v-if="isUpdate || isCreate">*</span>合同名称
          </template>
          <template v-slot="scope">
            <span v-if="isDetail">{{ scope.row.title }}</span>
            <vxe-input v-else v-model="scope.row.title" placeholder="必填" @blur="clearTableV"
                       @input="$refs.xTable1.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="busType" title="合同类型">
          <!--          <template v-slot:header>-->
          <!--            <span style="color: red">*</span>合同类型-->
          <!--          </template>-->
          <template v-slot="{ row }">
            <span v-if="isDetail">{{ row.busTypeText }}</span>
            <vxe-select v-else v-model="row.busType" placeholder="请选择" :options="bus_Type" transfer></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="companyName" title="平台企业">
          <template v-slot:header>
            <span style="color: red" v-if="isUpdate || isCreate">*</span>平台企业
          </template>
          <template v-slot="{ row }">
            <span v-if="isDetail">{{ row.companyName }}</span>
            <platform-corp v-else :row="row" :field="'companyName'" :placeholder="'请选择平台企业'"></platform-corp>
          </template>
        </vxe-table-column>
        <vxe-table-column field="clientName" title="签约方">
          <template v-slot:header>
            <span style="color: red" v-if="isUpdate || isCreate">*</span>签约方
          </template>
          <template v-slot="{ row }">
            <span v-if="isDetail">{{ row.clientName }}</span>
            <a class="sel-link" v-else @click="openClient" target="_black" style="cursor: pointer;text-align: center;">{{
                row.clientName === null ||
                row.clientName === "" ? "请选择账户" : row.clientName
              }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addTime" title="签约时间">
          <template v-slot:header>
            <span style="color: red" v-if="isUpdate|| isCreate">*</span>签约时间
          </template>
          <template v-slot="scope">
            <span v-if="isDetail">{{ scope.row.addTime | timeFormatDate }}</span>
            <vxe-input v-else v-model="scope.row.addTime" placeholder="请选择时间" type="date" transfer></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="备注">
          <template v-slot="scope">
            <span v-if="isDetail">{{ scope.row.note }}</span>
            <vxe-input v-else v-model="scope.row.note" placeholder="选填" @blur="clearTableV"
                       @input="$refs.xTable1.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-table
          ref="xTable2"
          show-overflow
          :auto-resize="true"
          class="table-upload-style"
          max-height="160"
          :loading="loading"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column field="attachFile" title="附件">
          <template v-slot="{ row }">
            <upload-list
                :isEdit="!isDetail || isCreate"
                :row="row"
                :initFileList="attachFile"
                :view="'arrange'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box" v-if="!isTax">
      <Button v-if="isDetail && !isOrder && isHavePermission('agreement2.0:update')" type="primary" @click="showUpdate">
        编 辑
      </Button>
      <Button v-if="!isDetail" type="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal v-model="clientVisible" title="选择账户" width="700" height="600" @close="closeAccount" resize
               position="center">
      <account-modal @choose="chooseClient" ref="clientModel"></account-modal>
    </vxe-modal>
  </div>
</template>
<script>
import PlatformCorp from "@/components/common/PlatformCorp";
import AccountModal from "@/components/modal/Account";
import UploadList from "@/components/common/UploadList";
import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {
    AccountModal,
    PlatformCorp,
    UploadList,
  },
  mixins: [getAuthOrization],
  props: {
    isTax: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    this.getDicContractBusType();
  },
  data() {
    return {
      loading: false,
      formData: [{
        id: null,
        clientName: null,
        companyName: null
      }],
      bus_Type: [], // 业务类型选择框
      attachFile: [],
      clientVisible: false,
      tableRules: {
        title: [{required: true, message: "请输入合同名称"}],
        // busType: [{required: true, message: "请选择合同类型"}],
        companyName: [{required: true, message: "请选择平台企业"}],
        clientName: [{required: true, message: "请选择签约方"}],
        addTime: [{required: true, message: "请选择签约时间"}],
      },
      isUpdate: false,
      isDetail: false,
      isOrder: false,
      isCreate: false,
    }
  },
  methods: {
    async validEvent() {
      let errMap = await this.$refs.xTable1
          .validate()
          .catch((errMap) => errMap);
      if (!errMap) {
        errMap = await this.$refs.xTable2.validate().catch((errMap) => errMap);
      }
      return errMap ? false : true;
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return;
      }
      // if (this.formData[0].fileUuidList.length === 0) {
      //   this.$XModal.message({status: "error", message: "请上传附件！"});
      //   return;
      // }
      if (!this.formData[0].id || this.formData[0].id === "") {
        this.save();
      } else {
        this.update();
      }
    },
    async save() {
      let obj = Object.assign({}, this.formData[0]);
      obj.addTime = this.$utils.timestamp(obj.addTime);
      obj.companyId = obj.companyNameId;
      obj.attachFile = obj.fileUuidList;
      showLoading();
      let res = await $api.agreementTwo.post("createContract", obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("提交成功");
        this.$emit("close");
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async update() {
      let obj = Object.assign({}, this.formData[0]);
      obj.addTime = this.$utils.timestamp(obj.addTime);
      obj.attachFile = obj.fileUuidList;
      showLoading();
      let res = await $api.agreementTwo.post("updateContract", obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.$emit("close");
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryContractDetail(id) {
      this.loading = true;
      let res = await $api.agreementTwo.post("queryContractDetail", {
        id: id,
      });
      this.loading = false;
      if (res.status === 1) {
        let data = res.data;

        let busTypeText = '';
        if (data.busType) {
          this.bus_Type.map(i => {
            if (i.value === parseInt(data.busType)) {
              busTypeText = i.label;
            }
          })
        }

        this.formData = [{
          id: data.id,
          numb: data.numb,
          title: data.title,
          note: data.note,
          busType: data.busType ? parseInt(data.busType) : null,
          busTypeText: busTypeText,
          clientName: data.clientName,
          clientId: data.clientId,
          companyName: data.companyName,
          companyId: data.companyId,
          addTime: this.$utils.toDateString(data.addTime, "yyyy-MM-dd"),
          createUser: data.createUser,
          createTime: data.createTime,
        }];
        if (data.fileList != null) {
          data.fileList.map((i) => {
            this.formData[0].fileUuidList.push(i.uuid);
          });
        }
        this.attachFile = data.attachFile;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.formData = [{
        id: null,
        clientName: null,
        companyName: null
      }];
      this.attachFile = [];
      this.isUpdate = false;
      this.isDetail = false;
      this.isOrder = false;
      this.isCreate = false;
      this.clearTable1V();
    },
    clearTable1V() {
      this.$refs.xTable1.clearValidate();
    },
    showDetail() {
      this.isUpdate = false;
      this.isDetail = true;
    },
    showUpdate() {
      this.isUpdate = true;
      this.isDetail = false;
      this.$emit('showUpdate')
    },
    showEdit() {
      this.isCreate = true;
      this.isDetail = false;
    },
    orderShow() {
      this.isOrder = true;
    },
    getDicContractBusType() {
      this.bus_Type = [];
      $api.other.getContractBusTypeModelTwo
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              let obj = {
                label: item.dictText,
                value: parseInt(item.dictCode),
              };
              this.bus_Type.push(obj);
            });
          });
    },
    //打开选择弹窗
    openClient() {
      this.clientVisible = true;
      this.$refs.clientModel.init();
    },
    //选择后回调填入数据
    chooseClient(row) {
      this.formData[0].clientId = row.id;
      this.formData[0].clientName = row.userName;
      this.clientVisible = false;
      this.$refs.clientModel.close();
    },
    closeAccount() {
      this.clientVisible = false;
      this.$refs.clientModel.close();
    },
    clearTableV() {
      this.$refs.xTable1.clearValidate();
    },
  }
}
</script>
<style>

</style>